import { useContext, useEffect, useState } from "react";
import IndieStaticSelect from "../IndieStaticSelect";
import { Skeleton } from "@mui/material";
import { TariffsContext } from "contexts/tariffs/TariffsContext";
import { useTranslation } from "react-i18next";

const IndieReceiptMethodsSelect = ({agent, ...params}) => {

    const [receiptMethods, setReceiptMethods] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getReceiptMethods, getAgentReceiptMethods } = useContext(TariffsContext);
    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);
        if(agent) {
            getAgentReceiptMethods(agent.id || agent).then((response) => {
                setReceiptMethods(response.data.map((item) => ({
                    value: item.id,
                    label: item.description
                })));
                setLoading(false);
            }).catch((error) => {
                console.error(error);
                setLoading(false);
            });
        } else {
            getReceiptMethods().then((response) => {
                setReceiptMethods(response.map((item) => ({
                    value: item.id,
                    label: item.description
                })));
                setLoading(false);
            }).catch((error) => {
                console.error(error);
                setLoading(false);
            });
        }
    }, []);

    if(loading) {
        return <Skeleton variant="rectangular" height={56} />
    }

    return (
        <IndieStaticSelect
            {...params}
            options={receiptMethods}
            label={t("label.form.receiptMethod")}
            sx={{width: 250}}
        />
    )
}

export default IndieReceiptMethodsSelect;